<template>
   <v-card
      outlined
      class="border-color: transparent !important"
      width="90%"
    >
      <v-card-text>
        <v-row align="center" justify="center">
          Progreso del proyecto:
        </v-row>
        <v-row >
          <v-progress-linear
            v-model="completedProgress"
            height="25"
          >
            <strong>{{ Math.ceil(completedProgress) }}%</strong>
          </v-progress-linear>
        </v-row>
        <v-row>
          <v-col cols="6"  class="pa-0"> 0% </v-col>
          <v-col cols="6"  class="pa-0 text-end"> 100% </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>
<script>
export default {
  props:{
    totalAmount:{
      type:Number,
      default:0
    },
    totalConsume:{
      type:Number,
      default:0
    }
  },
  computed:{
    completedProgress:{
      get(){
        if(this.totalAmount === this.totalConsume){
          return 100
        }
        if(this.totalConsume === 0){
          return 0
        }
        return (100*this.totalConsume)/this.totalAmount
      }
    }
  }
  
}
</script>